<!-- =========================================================================================
  File Name: DashboardAdmin.vue
  Description: Dashboard Admin
  ----------------------------------------------------------------------------------------
  Item Name: Vaagai Tecknowledge - Easy Admin
  Author: Web Team
  Author URL: http://www.vaagai.org.in/
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">

      <!-- Welcome Card -->
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
                    <img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" >
                    <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175">
          <!-- <feather-icon icon="AwardIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon> -->
          <clock size="100px" border="none" bg="radial-gradient(circle, #ecffe5, #fffbe1, #38ff91)"></clock>
          <h1 class="mb-6 text-white">Welcome {{ UserDisplayName }},</h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">You have done <strong>97.6%</strong> more sales today. This Dashboard explains statistic of your business.</p>
        </vx-card>
      </div>

      <!-- Total Receivable -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <card-total-receivables icon="UsersIcon" :statistic="ReceivableStatistic" statisticTitle="Total Receivable" :chartData="ReceivedChartData" type='area'></card-total-receivables>
      </div>

      <!-- Total Payable -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <card-total-payables icon="ShoppingBagIcon" :statistic="PayableStatistic" statisticTitle="Total Payable" :chartData="PaidChartData" color='warning' type='area'></card-total-payables>
      </div>
    </div>    

    <div class="vx-row">

      <!-- Receivable Table -->

      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card title="Top 10 Debtors">
          <div slot="no-body" class="mt-4">
            <vs-table :data="Debtors">
              <template slot="thead">
                <vs-th> # </vs-th>
                <vs-th> Ledger Name </vs-th>
                <vs-th> Amount </vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span> {{ indextr+1 }} </span>
                  </vs-td>
                  <vs-td>
                    <span> {{ tr.LedgerName }} </span>
                  </vs-td>
                  <vs-td>
                    <span> {{ tr.ClosingBalanceTxt }} </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>

        </vx-card>
      </div>

      <!-- Payable Table -->
      
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card title="Top 10 Creditors">
          <div slot="no-body" class="mt-4">
            <vs-table :data="Creditors">
              <template slot="thead">
                <vs-th> # </vs-th>
                <vs-th> Ledger Name </vs-th>
                <vs-th> Amount </vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span> {{ indextr+1 }} </span>
                  </vs-td>
                  <vs-td>
                    <span> {{ tr.LedgerName }} </span>
                  </vs-td>
                  <vs-td>
                    <span> {{ tr.ClosingBalanceTxt }} </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>

        </vx-card>
      </div>

    </div>

    <div class="vx-row">

      <!-- Cash Closing Balance -->

      <div class="vx-col w-full md:w-1/3 mb-base">
        <vx-card title="Cash Closing Balance">
          <div slot="no-body" class="mt-4">
            <vs-table :data="CashLedgers">
              <template slot="thead">
                <vs-th> # </vs-th>
                <vs-th> Cash Name </vs-th>
                <vs-th> Amount </vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span> {{ indextr+1 }} </span>
                  </vs-td>
                  <vs-td>
                    <span> {{ tr.LedgerName }} </span>
                  </vs-td>
                  <vs-td>
                    <span> {{ tr.ClosingBalanceTxt }} </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>

      <!-- Bank Closing Blance -->
      
      <div class="vx-col w-full md:w-1/3 mb-base">
        <vx-card title="Bank Closing Balance">
          <div slot="no-body" class="mt-4">
            <vs-table :data="BankLedgers">
              <template slot="thead">
                <vs-th> # </vs-th>
                <vs-th> Bank Name </vs-th>
                <vs-th> Amount </vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span> {{ indextr+1 }} </span>
                  </vs-td>
                  <vs-td>
                    <span> {{ tr.LedgerName }} </span>
                  </vs-td>
                  <vs-td>
                    <span> {{ tr.ClosingBalanceTxt }} </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>

      <!-- Wallet Closing Blance -->
      
      <div class="vx-col w-full md:w-1/3 mb-base">
        <vx-card title="Wallet Closing Balance">
          <div slot="no-body" class="mt-4">
            <vs-table :data="WalletLedgers">
              <template slot="thead">
                <vs-th> # </vs-th>
                <vs-th> Wallet Name </vs-th>
                <vs-th> Amount </vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span> {{ indextr+1 }} </span>
                  </vs-td>
                  <vs-td>
                    <span> {{ tr.LedgerName }} </span>
                  </vs-td>
                  <vs-td>
                    <span> {{ tr.ClosingBalanceTxt }} </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
      
    </div>
    
    <div class="vx-row">
        <!-- Income & Expenses -->
        <div class="vx-col w-full lg:w-1/2 mb-base">
            <vx-card title="Income & Expenses">
                <!-- CARD ACTION -->
                <!-- <template slot="actions">
                    <change-time-duration-dropdown />
                </template> -->

                <div slot="no-body">
                    <vue-apex-charts type="bar" height="350" :options="IncomeExpensesChartOptions" :series="IncomeExpensesChartSeries"></vue-apex-charts>
                </div>

            </vx-card>
        </div>

        <!-- Top Expenses -->
        <div class="vx-col w-full lg:w-1/2 mb-base">
            <vx-card title="Expenses">
                <!-- CARD ACTION -->
                <!-- <template slot="actions">
                    <change-time-duration-dropdown />
                </template> -->

                <div slot="no-body">
                    <vue-apex-charts type="bar" height="350" :options="ExpensesChartOptions" :series="ExpensesChartSeries"></vue-apex-charts>
                </div>
            </vx-card>
        </div>

    </div>

  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import ChangeTimeDurationDropdown from '@/views/dashboard/admin/ChangeTimeDurationDropdown.vue'
import companyConfig from '@/company_config.json'
import common from '@/views/Common.vue'
import CardTotalReceivables from '@/views/dashboard/admin/CardTotalReceivables.vue'
import CardTotalPayables from '@/views/dashboard/admin/CardTotalPayables.vue'
import Clock from 'vue-clock2';


export default {
    mixins: [common],
    components: {
        VueApexCharts,
        ChangeTimeDurationDropdown,
        CardTotalReceivables,
        CardTotalPayables,
        Clock
    },
    data() {
        return {

            UserDisplayName: '',
            result: [],

            isImp: false,
            navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
            show: false,
            items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            nextNum: 10,
            'tableList': [
                'vs-th: Component',
                'vs-tr: Component',
                'vs-td: Component',
                'thread: Slot',
                'tbody: Slot',
                'header: Slot'
            ],

            // Total Receivables Data LINE AREA CHART

            // ReceivableStatistic: 'Rs. 1000',
            ReceivableStatistic: '',
            /*
              {
                name: 'Subscribers',
                data: [28, 40, 36, 52, 38, 60, 55]
              }
            */
            ReceivedChartData: {
                series: [],
            },

            // Total Payables Data LINE AREA CHART

            // PayableStatistic: 'Rs. 1200',
            PayableStatistic: '',

            // [25, 35, 65, 45, 25, 95, 75]

            PaidChartData: {
                series: [],
            },

            Debtors: [],
            Creditors:[],
            CashLedgers:[],
            BankLedgers:[],
            WalletLedgers:[],

            // Income & Expenses Chart

            /* 
              [
                {
                  name: 'Income',
                  data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
                }, {
                  name: 'Expenses',
                  data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
                },
              ]
              */
            IncomeExpensesChartSeries: [],

            // ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov','Dec'],

            IncomeExpensesChartOptions: {
                      colors: ['#008000', '#ffa500', '#EA5455', '#FF9F43', '#1E1E1E'],
                      plotOptions: {
                        bar: {
                          horizontal: false,
                          endingShape: 'rounded',
                          columnWidth: '55%',
                        },
                      },
                      dataLabels: {
                        enabled: false
                      },
                      stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                      },

                      xaxis: {
                        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov','Dec'],
                      },
                      yaxis: {
                        title: {
                          text: 'Amount (Rs)'
                        }
                      },
                      fill: {
                        opacity: 1

                      },
                      tooltip: {
                        y: {
                          formatter: function(val) {
                            return "Rs " + val
                          }
                        }
                      }
                  },

            // Expenses Chart

            ExpensesChartSeries: [],

            // ['Team A', 'Team B', 'Team C', 'Team D'],
            /*
            ExpensesChartOptions: {
                labels: [],
                colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
                responsive: [
                  {
                    breakpoint: 480,
                    options: {
                      chart: {
                        width: 200
                      },
                      legend: {
                        position: 'bottom'
                      }
                    }
                  }
                ]
            },
            */
            //  ['Last Month', 'This Month']
            ExpensesChartOptions: {
                      colors: ['#008000', '#ffa500', '#EA5455', '#FF9F43', '#1E1E1E'],
                      plotOptions: {
                        bar: {
                          horizontal: false,
                          endingShape: 'rounded',
                          columnWidth: '55%',
                        },
                      },
                      dataLabels: {
                        enabled: false
                      },
                      stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                      },

                      xaxis: {
                        categories: ['Last Month', 'This Month'],
                      },
                      yaxis: {
                        title: {
                          text: 'Amount (Rs)'
                        }
                      },
                      fill: {
                        opacity: 1

                      },
                      tooltip: {
                        y: {
                          formatter: function(val) {
                            return "Rs " + val
                          }
                        }
                      }
                  },           
        }
    },
    beforeMount() {
        if (!this.$session.exists()) {
            console.log('your session is expired');
            this.$router.push('/');      
        }else{

          var server_url=companyConfig.apiURL;
          var username=this.$session.get('username');
          var role=this.$session.get('role');
          var UserDisplayName=this.$session.get('UserDisplayName');
          console.log('server_url='+server_url+', username='+username+', role='+role+', UserDisplayName='+UserDisplayName);

          this.UserDisplayName = UserDisplayName;

          // this.$vs.loading.close();

          // Fetch data from API

          var where = {
          };
          var url = 'lib/api/dashboard/admindashboard';
          this.getTableData('result', url, where);
          
        }
    },
    watch: {
      result: function(){            
        console.log('watch result='+JSON.stringify(this.result));
        var n1=Object.keys(this.result).length;
        console.log('n1='+n1);
        if (n1 > 0) {

          // Receivable Statistic

          var tempArray = [];

          var ReceivableStatistic = this.result.ReceivableStatistic;
          console.log('ReceivableStatistic='+ReceivableStatistic);
          this.ReceivableStatistic = ReceivableStatistic;

          // Receivable Statistic

          console.log('Before ReceivedChartData='+JSON.stringify(this.ReceivedChartData));
          tempArray.push(this.result.ReceivedChartData);
          console.log('ReceivedChartData='+JSON.stringify(tempArray));
          this.ReceivedChartData.series = tempArray;
          console.log('After ReceivedChartData='+JSON.stringify(this.ReceivedChartData));
          
          // PayableStatistic Statistic

          var PayableStatistic = this.result.PayableStatistic;
          console.log('PayableStatistic='+PayableStatistic);
          this.PayableStatistic = PayableStatistic;

          // Receivable Statistic

          tempArray = [];
          tempArray.push(this.result.PaidChartData);
          console.log('PaidChartData='+JSON.stringify(tempArray));
          this.PaidChartData.series = tempArray;

          // Debtors

          var Debtors = this.result.Debtors;
          console.log('Debtors='+JSON.stringify(Debtors));
          this.Debtors = Debtors;

          // Creditors

          var Creditors = this.result.Creditors;
          console.log('Creditors='+JSON.stringify(Creditors));
          this.Creditors = Creditors;

          // CashLedgers

          var CashLedgers = this.result.CashLedgers;
          console.log('CashLedgers='+JSON.stringify(CashLedgers));
          this.CashLedgers = CashLedgers;

          // BankLedgers

          var BankLedgers = this.result.BankLedgers;
          console.log('BankLedgers='+JSON.stringify(BankLedgers));
          this.BankLedgers = BankLedgers;

          // WalletLedgers

          var WalletLedgers = this.result.WalletLedgers;
          console.log('WalletLedgers='+JSON.stringify(WalletLedgers));
          this.WalletLedgers = WalletLedgers;

          // Income & Expenses Chart Series

          console.log('Before IncomeExpensesChartSeries='+JSON.stringify(this.IncomeExpensesChartSeries));
          tempArray = this.result.IncomeExpensesChartSeries;
          console.log('After IncomeExpensesChartSeries='+JSON.stringify(tempArray));
          this.IncomeExpensesChartSeries = tempArray;
          console.log('IncomeExpensesChartSeries='+JSON.stringify(this.IncomeExpensesChartSeries));

          // Income & Expenses Chart X Axis

          tempArray = [];
          console.log('Before IncomeExpensesChartXAxis='+JSON.stringify(this.IncomeExpensesChartOptions.xaxis.categories));
          tempArray = this.result.IncomeExpensesChartXAxis;
          console.log('After IncomeExpensesChartXAxis='+JSON.stringify(tempArray)+', type='+typeof tempArray);
          // this.IncomeExpensesChartOptions.xaxis.categories = tempArray;
          console.log('IncomeExpensesChartXAxis='+JSON.stringify(this.IncomeExpensesChartOptions.xaxis.categories));

          // Expenses Chart Series

          console.log('Before ExpensesChartSeries='+JSON.stringify(this.ExpensesChartSeries));
          tempArray = this.result.ExpensesChartSeries;
          console.log('After ExpensesChartSeries='+JSON.stringify(tempArray));
          this.ExpensesChartSeries = tempArray;
          console.log('ExpensesChartSeries='+JSON.stringify(this.ExpensesChartSeries));

          // Expenses Chart Labels

          tempArray = [];
          // console.log('Before ExpensesChartLabels='+JSON.stringify(this.ExpensesChartOptions.labels));
          console.log('Before ExpensesChartLabels='+JSON.stringify(this.ExpensesChartOptions.xaxis.categories));
          tempArray = this.result.ExpensesChartLabels;
          console.log('After ExpensesChartLabels='+JSON.stringify(tempArray)+', type='+typeof tempArray );
          // this.ExpensesChartOptions.labels = tempArray;
          // console.log('ExpensesChartLabels='+JSON.stringify(this.ExpensesChartOptions.labels));
          console.log('ExpensesChartLabels='+JSON.stringify(this.ExpensesChartOptions.xaxis.categories));

        }
      },
    }    
}
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user{
    position: relative;
    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
</style>
